import React from 'react';
import { Wallet, Home, Car, Briefcase } from 'lucide-react';
import i18n from '../i18n/config';

const LoanTypes: React.FC = () => {
  const loanTypes = [
    {
      id: 'consumer',
      title: i18n.t('loan_types.consumer.title'),
      description: i18n.t('loan_types.consumer.description'),
      icon: Wallet,
      color: '#3498db',
      anchor: i18n.t('anchor_links.consumer')
    },
    {
      id: 'mortgage',
      title: i18n.t('loan_types.mortgage.title'),
      description: i18n.t('loan_types.mortgage.description'),
      icon: Home,
      color: '#1abc9c',
      anchor: i18n.t('anchor_links.mortage')
    },
    {
      id: 'car',
      title: i18n.t('loan_types.car.title'),
      description: i18n.t('loan_types.car.description'),
      icon: Car,
      color: '#f1c40f',
      anchor: i18n.t('anchor_links.car')
    },
    {
      id: 'business',
      title: i18n.t('loan_types.business.title'),
      description: i18n.t('loan_types.business.description'),
      icon: Briefcase,
      color: '#3498db',
      anchor: i18n.t('anchor_links.business')
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-white to-[#f9fafb]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <h2 className="text-4xl font-bold text-[#2c3e50]">{i18n.t('loan_types.title')}</h2>
            <div className="space-y-6">
              {loanTypes.map((loanType) => {
                const IconComponent = loanType.icon;
                return (
                  <a
                    key={loanType.id}
                    href={`/${i18n.t('routes.loan_types')}#${loanType.anchor}`}
                    className="flex items-start p-6 bg-white border border-[#3498db]/30 hover:border-[#3498db] hover:shadow-lg transition-all duration-300 cursor-pointer group"
                    style={{
                      borderColor: `${loanType.color}30`,
                      '--hover-border-color': loanType.color
                    } as React.CSSProperties}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = loanType.color;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = `${loanType.color}30`;
                    }}
                  >
                    <div className="flex-shrink-0 mt-1">
                      <IconComponent 
                        className="h-8 w-8 transition-colors duration-300" 
                        style={{ color: loanType.color }}
                      />
                    </div>
                    <div className="ml-6">
                      <h3 className="text-2xl font-semibold text-[#2c3e50] mb-3 group-hover:text-[#2c3e50] transition-colors duration-300">
                        {loanType.title}
                      </h3>
                      <p className="text-[#2c3e50]/80 leading-relaxed group-hover:text-[#2c3e50]/90 transition-colors duration-300">
                        {loanType.description}
                      </p>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#3498db]/20 to-[#1abc9c]/20 transform rotate-1"></div>
            <div className="relative bg-white p-8 border border-[#3498db]/30 shadow-xl">
              <div className="h-96 bg-gradient-to-br from-[#3498db]/10 to-[#1abc9c]/10 flex items-center justify-center mb-8 border border-[#3498db]/30">
                <img 
                  src="/images/image_1.webp"
                  alt="Happy finance woman"
                  className="w-full h-full object-cover object-center shadow-lg"
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#3498db]/10 p-6 border border-[#3498db]/30 hover:border-[#3498db]/50 transition-all duration-300">
                  <h4 className="text-xl font-semibold text-[#2c3e50] mb-3">{i18n.t('features.quick_process.title')}</h4>
                  <p className="text-[#3498db] font-medium">{i18n.t('features.quick_process.description')}</p>
                </div>
                <div className="bg-[#1abc9c]/10 p-6 border border-[#1abc9c]/30 hover:border-[#1abc9c]/50 transition-all duration-300">
                  <h4 className="text-xl font-semibold text-[#2c3e50] mb-3">{i18n.t('features.great_rates.title')}</h4>
                  <p className="text-[#1abc9c] font-medium">{i18n.t('features.great_rates.description')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanTypes; 